import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { copyFiltersToClipboard,pasteFiltersFromClipboard } from "./filtersclipboard";

interface Props {
    filters: any[];
    setFilters: (filters: any[]) => void;
}

export const CopyPasteFilters = ({
  filters,
  setFilters,
}: Props) => {
  const handleCopy = async () => {
        try 
        {
          await copyFiltersToClipboard(filters);
        } catch (err) {
          console.error('Failed to copy filters:', err);
        }
    };

    const handlePaste = async () => {
        try 
        {
          const pastedFilters = await pasteFiltersFromClipboard();
          setFilters(pastedFilters);
        } catch (err) {
          console.error('Failed to paste filters:', err);
        }
    };

    return (
    <Stack direction="row" spacing={2}>
      <Button
        variant="contained"
        onClick={handleCopy}
      >
        Copy Filters
      </Button>

      <Button
        variant="outlined"
        onClick={handlePaste}
      >
        Paste Filters
      </Button>
    </Stack>
  );
};